import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MomMeetingRoutingModule } from './mom-meeting-routing.module';
import { MomRecordMeetingComponent } from '../mom-record-meeting/mom-record-meeting.component';


@NgModule({
  declarations: [
    
    
  ],
  imports: [
    CommonModule,
    MomMeetingRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule
  ]
})
export class MomMeetingModule { }
